import controller from './motion.controller';

const template = require('./motion.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
